import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "233599827348";
const WHATSAPP_TEXT = "Hello StaffLink Ghana — I'd like to learn more about your business automation solutions.";
const buildWhatsAppLink = () =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_TEXT)}`;

export const WhatsAppFab = () => {
  return (
    <a
      href={buildWhatsAppLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
    >
      <span className="pulse-ring" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1FBE58] text-white rounded-full pl-4 pr-5 py-3 shadow-lg transition-colors duration-300">
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline font-medium text-sm">Chat on WhatsApp</span>
      </span>
    </a>
  );
};

export default WhatsAppFab;
